/* Erntepur Warenkorb-Drawer (aus Schnurrkraft) (26.09.2026)
   1. Zugaben synchron halten: Aendert jemand im Drawer die Menge oder loescht das Produkt, stimmen die
      Gratis-Zugaben wieder mit der Dosenzahl ueberein (Loeffel ab 1, Geschenk ab 2, ohne Kaufprodukt keine).
      Welche Zugaben es gibt und ab welcher Stufe, steht im Drawer selbst ([data-jlc-gifts]).
   2. Oeffnen: .jlc-cd-open fuer die Einblend-Animationen, .jlc-cd-new fuer frisch freigeschaltete Stufen. */
(function(){
  if(window.__jlcCart)return;window.__jlcCart=true;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
  var busy=false,lastTins=null;

  function drawer(){return document.querySelector("cart-drawer");}
  function tinsOf(cart,giftIds){
    var t=0;cart.items.forEach(function(i){if(giftIds.indexOf(i.variant_id)>-1)return;var n=String(i.variant_title||'').split('+').reduce(function(a,x){return a+(parseInt(x,10)||0);},0);t+=(n||1)*i.quantity;});return t;
  }
  function markNew(before){
    var d=drawer();if(!d)return;
    var prog=d.querySelector("[data-jlc-gifts]");if(!prog)return;
    var now=+prog.dataset.tins||0;
    if(before!==null&&now>before){
      d.querySelectorAll(".jlc-cd-ms").forEach(function(m){if(+m.dataset.lvl>before&&+m.dataset.lvl<=now)m.classList.add("jlc-cd-new");});
      d.querySelectorAll(".jlc-cd-gift").forEach(function(g){if(+g.dataset.lvl>before)g.classList.add("jlc-cd-new");});
    }
    lastTins=now;
  }
  function rerender(){
    return fetch(root+"?sections=cart-drawer,cart-icon-bubble",{cache:"no-store"}).then(function(r){return r.json();}).then(function(s){
      var d=drawer(),doc=new DOMParser().parseFromString(s["cart-drawer"],"text/html"),fresh=doc.querySelector("cart-drawer");
      if(d&&fresh){
        var before=lastTins;
        d.querySelector(".drawer__inner").innerHTML=fresh.querySelector(".drawer__inner").innerHTML;
        d.classList.toggle("is-empty",fresh.classList.contains("is-empty"));
        var items=d.querySelector("cart-drawer-items");if(items)items.classList.toggle("is-empty",fresh.classList.contains("is-empty"));
        markNew(before);
      }
      var b=document.getElementById("cart-icon-bubble");
      if(b&&s["cart-icon-bubble"]){var bd=new DOMParser().parseFromString(s["cart-icon-bubble"],"text/html").querySelector(".shopify-section");if(bd)b.innerHTML=bd.innerHTML;}
    });
  }
  function sync(){
    var el=document.querySelector("[data-jlc-gifts]");if(!el||busy)return;
    var gifts;try{gifts=JSON.parse(el.dataset.jlcGifts||"[]");}catch(e){return;}
    if(!gifts.length)return;
    busy=true;
    var ids=gifts.map(function(g){return g.id;});
    fetch(root+"cart.js",{cache:"no-store"}).then(function(r){return r.json();}).then(function(cart){
      var tins=tinsOf(cart,ids),adds=[],updates={};
      gifts.forEach(function(g){
        var want=tins>=g.lvl?1:0,lines=cart.items.filter(function(i){return i.variant_id===g.id;});
        var have=lines.reduce(function(a,i){return a+i.quantity;},0);
        if(have===want)return;
        if(want&&!have)adds.push({id:g.id,quantity:1,properties:{"Zugabe":"Gratis"}});
        else lines.forEach(function(i,k){updates[i.key]=k===0?want:0;});
      });
      var chain=Promise.resolve(),changed=false;
      if(Object.keys(updates).length){changed=true;chain=chain.then(function(){return fetch(root+"cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({updates:updates})});});}
      if(adds.length){changed=true;chain=chain.then(function(){return fetch(root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:adds})});});}
      return chain.then(function(){return changed?rerender():null;});
    }).catch(function(){}).then(function(){busy=false;});
  }

  function onOpen(d){
    d.classList.remove("jlc-cd-open");void d.offsetWidth;d.classList.add("jlc-cd-open");
    clearTimeout(d._jlcT);d._jlcT=setTimeout(function(){d.classList.remove("jlc-cd-open");},1600);
  }
  function watch(){
    var d=drawer();if(!d)return;
    var prog=d.querySelector("[data-jlc-gifts]");if(prog)lastTins=+prog.dataset.tins||0;
    new MutationObserver(function(){var on=d.classList.contains("active");if(on&&!d._jlcOn)onOpen(d);d._jlcOn=on;}).observe(d,{attributes:true,attributeFilter:["class"]});
    /* Dawn ersetzt beim Mengenwechsel .drawer__inner: danach neue Stufen markieren und Zugaben abgleichen */
    new MutationObserver(function(){var p=d.querySelector("[data-jlc-gifts]");if(p&&+p.dataset.tins!==lastTins){var before=lastTins;markNew(before);}}).observe(d,{childList:true,subtree:true});
    if(typeof subscribe==="function"&&typeof PUB_SUB_EVENTS!=="undefined")subscribe(PUB_SUB_EVENTS.cartUpdate,function(e){if(e&&e.source==="cart-items")sync();});
  }
  /* Gipfelstark 28.09.2026: Klick neben den Drawer (Overlay) schliesst immer. Dawn bindet den Klick direkt ans Overlay;
     wird der Drawer neu gezeichnet (z. B. nach der Rueckkehr aus dem Checkout), fehlt der Handler. Delegiert am Dokument
     ueberlebt er jedes Neuzeichnen. */
  document.addEventListener("click",function(e){
    var t=e.target;if(!t||!t.closest||!t.closest("#CartDrawer-Overlay"))return;
    var d=drawer();if(d&&d.classList.contains("active")&&typeof d.close==="function")d.close();
  });
  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",watch):watch();
})();
